import React, {  useState } from 'react';
import Sidebar from './Sidebar'
import Header from './Header'
import Footer from './Footer'
import { Outlet } from 'react-router-dom'



const Layout = ({projectsData, projectOwnersData, investorsData, transformProjectsData}) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true); // Add this line

  // Function to toggle the sidebar
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  return (
    <div className='flex flex-row bg-neutral-100 min-h-screen'>
      <Sidebar 
        isOpen={isSidebarOpen} // Pass the state and the toggle function as props
        toggleSidebar={toggleSidebar}
        // projectsData={projectsData} projectOwnersData={projectOwnersData} 
        // investorsData={investorsData} transformProjectsData={transformProjectsData} 
      />
      {/* <div className='flex-1' >
        <Header /> */}
      <div className={`flex-1 transition-all duration-300 ${isSidebarOpen ? 'ml-64' : 'ml-12'}`}>
        <Header toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} /> 
        <div className='p-4'>
          <Outlet />
          {/* <Footer /> */}
        </div>
      </div>
    </div>
  )
}

export default Layout
